const {debounce} = require('../helpers/_utils');

module.exports = function init_header() {

  // mobile toggle
  const nav_menu = document.querySelector('.nav-menu');
  const menu_toggle = document.querySelector('.menu-toggle');
  if (menu_toggle && nav_menu) {
    menu_toggle.addEventListener('click', function() {
        nav_menu.classList.toggle('toggled');
        this.setAttribute('aria-expanded', 
            this.getAttribute('aria-expanded') === 'true' ? 'false' : 'true'
        );
    });
  }

  // header height variable
  function set_header_height() {
    const header = document.querySelector('header'); // Adjust selector if needed
    if (header) {
        const headerHeight = header.offsetHeight;
        document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
    }
  }
  
  set_header_height();

  // add event listener for window resize, using debounce
  window.addEventListener('resize', debounce(() => {
    set_header_height();
  }));

  // below-hero-inverse functionality
  if(document.querySelector('header.below-hero-inverse')) {
    // listen for scroll below hero row
    const builder_content = document.querySelector('.fl-builder-content');
    const hero_row = builder_content ? builder_content.querySelector('.fl-row') : null;
    const header = document.querySelector('header');

    if (hero_row && header) {
      const update_header_class = () => {
          const header_height = header.offsetHeight;
          const row_rect = hero_row.getBoundingClientRect();
          const row_viz_ht = Math.max(0, Math.min(row_rect.bottom, window.innerHeight) - Math.max(row_rect.top, 0));

          if (row_viz_ht <= header_height && row_rect.bottom <= window.innerHeight) {
              // Add class when visible part of the row is equal to or less than header height
              // and the bottom of the row is still in the viewport
              header.classList.add('below-hero-active');
          } else {
              header.classList.remove('below-hero-active');
          }
      };

      // Initial check
      update_header_class();

      // Check on scroll
      window.addEventListener('scroll', update_header_class);

      // Update on resize
      window.addEventListener('resize', update_header_class);
    }
  }

};